import { ApiService } from "src/network/apiService";
import { BusinessListModel } from "src/types/models/business";

export class BusinessListViewModel {
    private apiService: ApiService;

    constructor(accessToken: string) {
        this.apiService = new ApiService({ accessToken: accessToken });
    }

    async fetchList(): Promise<BusinessListModel[]> {
        const response = await this.apiService.getAsync<any>(
            "/onboard/business/unapproved-businesses"
        );

        if (response) {
            if (response.scResponse && response.scResponse.code === 2000) {
                const sortedBusinesses = response.scResponse.data.sort((a: { businessCode: number; }, b: { businessCode: number; }) => {
                    if (a.businessCode < b.businessCode) return -1; // a comes before b
                    if (a.businessCode > b.businessCode) return 1; // a comes after b
                    return 0; // a and b are equal
                });
                return sortedBusinesses;
            }

            return [];
        }

        return [];
    }
}
